// eslint-disable-next-line
// @ts-nocheck
import '../components/nav/nav';
import Sidebar from '../components/sidebar';
import ContextMenu from '../components/contextMenu';
import alertModule from '../components/alert';
import './NavigationPanelTabs';
import utils from '../core/utils';
import { contentTabId } from './sidebarDataConverter';
import secondaryMenu from './secondaryMenu';
import SvgManager from '../core/SvgManager';
import getResource from '../core/resources';
import { itemType as itemTypeMetadata } from 'metadata';
import { commands } from 'cui';
import { favorites as favoriteMethods } from 'store';

/* Custom 2024-04-11: jake.9; 검색 아이콘을 클릭하면 검색 뷰 대신에 2차 메뉴를 표시하도록 수정 */
const icons = {
	back: '../images/BackFull.svg',
	close: '../images/Close.svg',
	defaultItemType: '../images/DefaultItemType.svg',
	search: '../images/RightArrow.svg',
	open: '../images/OpenInTab.svg',
	pinned: '../images/PinnedOn.svg',
	savedSearch: '../images/SavedSearchOverlay.svg',
	unpinned: '../images/PinnedOff.svg'
};
/* End of Custom */

SvgManager.enqueue(Object.values(icons));

const disabledRowHighlightingClass =
	'aras-navigation-panel_row-highlighting-disabled';

function navFormatter(nav, item) {
	const itemValue = item.value;
	if (itemValue.children) {
		return null;
	}

	const isDashboardItem = itemValue.dashboard;
	if (itemValue.itemTypeId || isDashboardItem) {
		const leafTemplate = nav.templates.getDefaultTemplate(item);
		const nodeClassList = isDashboardItem
			? 'aras-nav-leaf-ico'
			: 'aras-button aras-button_c aras-nav-leaf-ico';
		/* Custom 2024-06-14: jake.9; 아이템 유형에 대한 TOC 메뉴가 아니면 아이콘을 표시하지 않도록 수정 */
		const nodeIconUrl = isDashboardItem ? '' : icons.search;

		leafTemplate.push(
			Inferno.createVNode(
				Inferno.getFlagsForElementVnode('span'),
				'span',
				nodeClassList,
				nodeIconUrl ? SvgManager.createInfernoVNode(nodeIconUrl) : null,
				utils.infernoFlags.unknownChildren
			)
		);
		/* End of Custom */

		return leafTemplate;
	}

	return null;
}

function getFavoriteCategories(itemTypeName, options) {
	const favorites = options.favorites;
	const favoritesFilterCriteria = (favoriteItem) => {
		return (
			favoriteItem.quickAccessFlag === '1' &&
			favoriteItem.contextType === itemTypeName
		);
	};
	const [favoriteSearches, favoriteItems] = ['Search', 'Item'].map((type) =>
		favoriteMethods.filterFavorites(favorites, type, favoritesFilterCriteria)
	);

	const favoriteCategories = [];
	if (favoriteSearches.length) {
		const label = getResource(
			'navigation_panel.secondary_menu.favorite_searches'
		);
		favoriteCategories.push({
			icon: options.icon,
			overlayIcons: [icons.savedSearch],
			unpinIcon: icons.close,
			label,
			items: favoriteSearches
		});
	}
	if (favoriteItems.length) {
		favoriteCategories.push({
			icon: options.icon,
			label: options.pluralLabel,
			items: favoriteItems
		});
	}
	return favoriteCategories;
}

async function getItemTypeData(itemTypeId) {
	const itemType = await itemTypeMetadata.getItemType(itemTypeId, 'id');
	const itemTypeName = itemType.name;
	const singularLabel = itemType.label || itemTypeName;
	const propertiesWithKeyedName =
		itemTypeMetadata.getKeyedNameConfiguration(itemType);
	const newCommand = createCommand('OpenNewItem', itemType);
	const canAdd = newCommand.canExecute();
	const openForbidden = window.isFunctionDisabled(itemTypeName, 'Open');
	const isQuickSearchDisabled =
		openForbidden || !propertiesWithKeyedName.length;

	return {
		canAdd,
		isQuickSearchDisabled,
		itemType,
		itemTypeName,
		singularLabel
	};
}

function createCommand(commandName, itemType, options = {}) {
	const itemTypeName = itemType?.name;

	return commands.commandFactory(commandName, {
		itemType,
		itemTypeName,
		location: 'MainWindowView',
		...options
	});
}

export default class NavigationPanel extends Sidebar {
	nav = document.createElement('aras-nav');
	tabs = document.createElement('aras-navigation-panel-tabs');
	state = {
		secondaryMenuItemTypeId: null,
		secondaryMenuData: null,
		favorites: {}
	};

	togglePin(pinned) {
		super.togglePin(pinned);
		this.render();
	}

	toggleVisibility(visible) {
		super.toggleVisibility(visible);
		const splitter = this.nextElementSibling;
		const isVisible = this.isVisible;
		splitter.classList.toggle('aras-hide', !isVisible);
		if (isVisible && this.isPinned) {
			setTimeout(() => {
				this.focus();
			});
		}
	}

	focus() {
		if (!this.state.secondaryMenuItemTypeId) {
			return super.focus();
		}

		const quickSearch = this.querySelector(
			'.aras-secondary-menu__quick-search:not([disabled])'
		);

		if (quickSearch) {
			quickSearch.focus();
		} else {
			const navHeader = this.querySelector('.aras-navigation-panel__header');
			navHeader.focus();
		}
	}

	render() {
		this.state.secondaryMenuData = this._getSecondaryMenuData();
		const secondaryMenuData = this.state.secondaryMenuData;
		const contentsTitle = secondaryMenuData
			? secondaryMenuData.pluralLabel
			: getResource('common.contents');

		const pinIcon = this.isPinned ? icons.pinned : icons.unpinned;
		const pinIconNode = SvgManager.createHyperHTMLNode(pinIcon, {
			cssClass: 'aras-button__icon'
		});
		const backTitle = getResource(
			'navigation_panel.secondary_menu.back_to_contents'
		);
		this.html`
		<div class="aras-navigation-panel__header" tabindex="0" aria-label="${contentsTitle}">
			<button
				class="${'aras-button aras-button_c ' + (secondaryMenuData ? '' : 'aras-hide')}"
				onclick="${() => this._hideSecondaryMenu()}"
				title="${backTitle}"
			>
				${SvgManager.createHyperHTMLNode(icons.back, {
					cssClass: 'aras-button__icon'
				})}
			</button>
			${SvgManager.createHyperHTMLNode(secondaryMenuData?.icon, {
				cssClass: 'aras-navigation-panel__header-icon'
			})}
			<span class="aras-navigation-panel__header-title">
				${contentsTitle}
			</span>
			<span
				class="aras-navigation-panel__pin-icon aras-button aras-button_c"
				onclick="${() => this.togglePin()}"
			>
				${pinIconNode}
			</span>
		</div>
		${this.nav}
		${secondaryMenu(this)}
		${this.tabs}`;
	}

	connectedCallback() {
		super.connectedCallback();
		this.classList.add('aras-navigation-panel', disabledRowHighlightingClass);
		this.setAttribute('role', 'navigation');
		this.popupMenu = new ContextMenu();
		this._initContextMenuHandlers();
		this._initContextMenuListeners();
		const observer = new MutationObserver((mutations) => {
			const navPanel = mutations[0].target;
			const panelWidth = navPanel.style.width;
			navPanel.nextElementSibling.style.left = panelWidth;
		});

		observer.observe(this, {
			attributes: true,
			attributeFilter: ['style']
		});
		this.render();
	}

	created() {
		this._initTOC();
		this._initTabs();
	}

	resetState() {
		this.state.secondaryMenuData = null;
		this.render();
	}

	_initContextMenuHandlers() {
		const sidebarTabs = this.tabs;
		const contextMenuMethods = {
			pinItemType: (id, tabData) => sidebarTabs.addTab(id, tabData),
			unpinItemType: (id) => {
				const tabsData = sidebarTabs.data;
				const removedTab = tabsData.get(id);
				sidebarTabs.removeTab(id);
				return removedTab;
			},
			getItemTypeByItemTypeId: (itemTypeId) => {
				let tabId;
				const tabsData = sidebarTabs.data;
				tabsData.forEach((data, id) => {
					if (data.itemTypeId === itemTypeId) {
						tabId = id;
					}
				});
				return tabsData.get(tabId);
			},
			openSearch: (...args) => window.arasTabs.openSearch(...args)
		};
		const dispatchContextMenuEvent = (location, event, options) => {
			event.preventDefault();
			const detail = {
				location,
				x: event.clientX,
				y: event.clientY,
				...options
			};
			const cuiEvent = new CustomEvent('navigationPanelContextMenu', {
				detail
			});
			this.dispatchEvent(cuiEvent);
		};
		sidebarTabs.on('contextmenu', (itemKey, event) => {
			const currentTarget = sidebarTabs.data.get(itemKey);
			const itemTypeName = currentTarget.contextType;
			const options = {
				currentTarget,
				itemTypeName,
				...contextMenuMethods
			};
			dispatchContextMenuEvent('PopupMenuMainWindowTOC', event, options);
		});
		const nav = this.nav;
		nav.on('contextmenu', (itemKey, event) => {
			nav.select(itemKey);
			const currentTarget = nav.data.get(itemKey);
			const itemTypeId = currentTarget.itemTypeId;
			const options = {
				currentTarget,
				itemTypeId,
				...contextMenuMethods
			};
			dispatchContextMenuEvent('PopupMenuMainWindowTOC', event, options);
		});
		this._favoritesContextMenuHandler = (event) => {
			const favoriteItemRow = event.target.closest('.aras-nav__child');
			if (!favoriteItemRow) {
				return;
			}

			favoriteItemRow.classList.add('aras-nav__child_selected');
			const unselectHighlightedItem = () => {
				favoriteItemRow.classList.remove('aras-nav__child_selected');
				this.popupMenu.dom.removeEventListener(
					'contextMenuClose',
					unselectHighlightedItem
				);
			};
			this.popupMenu.dom.addEventListener(
				'contextMenuClose',
				unselectHighlightedItem
			);

			const favoriteId = favoriteItemRow.dataset.id;
			const currentTarget = this.state.favorites[favoriteId];
			const itemTypeName = currentTarget.contextType;
			const options = {
				currentTarget,
				itemTypeName
			};
			dispatchContextMenuEvent('PopupMenuSecondaryMenu', event, options);
		};
	}

	_initContextMenuListeners() {
		const contextMenuDom = this.popupMenu.dom;
		contextMenuDom.addEventListener('contextMenuShow', () => {
			this.classList.remove(disabledRowHighlightingClass);
		});
		contextMenuDom.addEventListener('contextMenuClose', (e) => {
			this.classList.add(disabledRowHighlightingClass);
			if (e.detail.type === 'keydown') {
				this.focus();
				return;
			}

			if (!this.isPinned) {
				setTimeout(() => {
					this.closeIfNotAcitive(document.activeElement);
				});
			}
		});
		contextMenuDom.addEventListener('click', () => {
			this._hideIfNotPinned();
		});
	}

	closeIfNotAcitive(element) {
		const isElement = Boolean(element && this.contains(element));
		const isContextMenu = Boolean(
			element && this.popupMenu.dom.contains(element)
		);
		if (!(isElement || isContextMenu)) {
			this.toggleVisibility(false);
		}
	}

	_initTOC() {
		const selectTab = (dataItem) => {
			const tabs = this.tabs;
			tabs.data.forEach((tabItem, id) => {
				if (tabItem.itemTypeId === dataItem.itemTypeId) {
					tabs.selectTab(id);
				}
			});
		};
		this.nav.classList.add('aras-nav-toc');
		this.nav.formatter = navFormatter.bind(null, this.nav);
		const handler = async (itemKey, event) => {
			if (
				event.type === 'keydown' &&
				!['Enter', 'Space', 'NumpadEnter'].includes(event.code)
			) {
				return;
			}
			/* Custom 2024-04-09: jake.9; TOC 메뉴(아이템 유형)를 클릭하면 2차 메뉴 대신에 검색 뷰를 표시하도록 수정 */
			const dataItem = this.nav.data.get(itemKey);
			const isNewTabOpened =
				dataItem.dashboard;
			const searchIconNode = event.target.closest('.aras-button.aras-nav-leaf-ico');
			if (isNewTabOpened) {
				this._hideIfNotPinned();
			} else if (dataItem.itemTypeId && !searchIconNode) {
				window.arasTabs.openSearch(dataItem.itemTypeId);
				this._hideIfNotPinned();
			}
			/* End of Custom */ 
		};
		this.nav.on('click', handler);
		this.nav.on('keydown', handler);
	}

	_initTabs() {
		this.tabs.on('select', (id) => {
			if (id === contentTabId) {
				this._hideSecondaryMenu();
				return;
			}

			const item = this.tabs.data.get(id);
			this._showSecondaryMenu(item.itemTypeId);
		});
		this.tabs.on('click', (id) => {
			if (id === contentTabId) {
				this._hideSecondaryMenu();
			}
		});
	}

	_hideIfNotPinned() {
		if (!this.isPinned) {
			this.toggleVisibility(false);
			document.documentElement.focus(); // for correct work of sidebar in IE and FF
		}
	}

	_getSecondaryMenuData() {
		const itemTypeId = this.state.secondaryMenuItemTypeId;
		if (!itemTypeId) {
			return null;
		}

		const items = [...this.nav.data.values()];
		const item = items.find(
			(item) => item.itemTypeId === itemTypeId && !item.dashboard
		);
		if (!item) {
			this._hideSecondaryMenu();
			return null;
		}

		const { icon = icons.defaultItemType, label: pluralLabel } = item;
		const itemTypeName = itemTypeMetadata.getItemTypeName(itemTypeId);
		const favoriteCategories = getFavoriteCategories(itemTypeName, {
			icon,
			pluralLabel,
			favorites: this.state.favorites
		});

		if (this.state.secondaryMenuData?.itemTypeId === itemTypeId) {
			return {
				...this.state.secondaryMenuData,
				favoriteCategories
			};
		}

		const loggedUserIdentity = aras.getIsAliasIdentityIDForLoggedUser();
		const secondaryMenuData = {
			canAdd: false,
			favoriteCategories,
			icon,
			itemTypeId,
			itemTypeName,
			isQuickSearchDisabled: true,
			loggedUserIdentity,
			pluralLabel,
			singularLabel: itemTypeName
		};

		this._updateSecondaryMenuData(itemTypeId);

		return secondaryMenuData;
	}

	_showSecondaryMenu(itemTypeId) {
		this.state.secondaryMenuItemTypeId = itemTypeId;
		this.render();
		this.nav.style.visibility = 'hidden';
		this.focus();
	}

	_hideSecondaryMenu() {
		this.state.secondaryMenuItemTypeId = null;
		this.tabs.selectTab(contentTabId);
		this.render();
		this.nav.style.visibility = 'visible';
		this.nav.focus();
	}

	async _updateSecondaryMenuData(itemTypeId) {
		const itemTypeData = await getItemTypeData(itemTypeId);
		if (this.state.secondaryMenuItemTypeId !== itemTypeId) {
			return;
		}

		this.state.secondaryMenuData = {
			...this.state.secondaryMenuData,
			...itemTypeData
		};
		this.render();
		this.focus();
	}

	async _favoritesClick(event) {
		const favoriteItemRow = event.target.closest('.aras-nav__child');
		if (!favoriteItemRow) {
			return;
		}

		const favoriteId = favoriteItemRow.dataset.id;
		const favoriteItem = this.state.favorites[favoriteId];
		const unpinIconNode = event.target.closest(
			'.aras-button.aras-nav-leaf-ico'
		);
		if (unpinIconNode) {
			favoriteMethods.removeFromQuickAccess(favoriteId);
		} else if (favoriteItem.category === 'Item') {
			const favoriteItemType = favoriteItem.contextType;
			const itemType = await itemTypeMetadata.getItemType(favoriteItemType);
			const isVersionable = itemType['is_versionable'] === '1';
			const getItemMethod = isVersionable
				? 'getItemLastVersion'
				: 'getItemById';
			const itemNode = aras[getItemMethod](
				favoriteItemType,
				favoriteItem.additional_data.id
			);
			const openCommand = createCommand('OpenItem', itemType, { itemNode });
			if (openCommand.canExecute()) {
				await openCommand.execute();

				return this._hideIfNotPinned();
			}

			const errorMessage = getResource(
				'ui_methods.access_restricted_or_not_exist',
				favoriteItemType
			);
			alertModule(errorMessage, {
				type: 'error'
			});
		} else if (favoriteItem.category === 'Search') {
			this._searchItemType(this.state.secondaryMenuItemTypeId, favoriteId);
		}
	}

	async _createNewItem() {
		const { itemType } = this.state.secondaryMenuData;
		const openNewItemCommand = createCommand('OpenNewItem', itemType);

		await openNewItemCommand.execute();

		this._hideIfNotPinned();
	}

	_searchItemType(itemTypeId, favoriteSearchId) {
		return Promise.resolve(
			window.arasTabs.openSearch(itemTypeId, favoriteSearchId)
		).then(() => {
			this._hideIfNotPinned();
		});
	}

	async _openItem(event) {
		const quickSearch = event.currentTarget;
		const selectedItem = quickSearch.getSelectedItem();
		if (!selectedItem) {
			return;
		}
		quickSearch.clear();

		const { itemType } = this.state.secondaryMenuData;
		const itemNode = aras.getItemById(itemType.name, selectedItem.itemId);
		const openCommand = createCommand('OpenItem', itemType, { itemNode });
		if (openCommand.canExecute()) {
			openCommand.execute();
		}
	}
}

NavigationPanel.define('aras-navigation-panel');
